"use strict";

var _context, _context2, _context3;
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _CompactSlots = require("./CompactSlots");
_forEachInstanceProperty(_context = _Object$keys(_CompactSlots)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CompactSlots[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CompactSlots[key];
    }
  });
});
var _InlineSlots = require("./InlineSlots");
_forEachInstanceProperty(_context2 = _Object$keys(_InlineSlots)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InlineSlots[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InlineSlots[key];
    }
  });
});
var _ReadOnlySlots = require("./ReadOnlySlots");
_forEachInstanceProperty(_context3 = _Object$keys(_ReadOnlySlots)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReadOnlySlots[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ReadOnlySlots[key];
    }
  });
});